export class CookiePurpose {
}
CookiePurpose.Analytics = "analytics";
CookiePurpose.Social = "socialsharing";
CookiePurpose.Preferences = "preferences";
//# sourceMappingURL=CookiePurpose.js.map